import { addressParts, bookingKeyOfCustom, splitName } from "../lib/booking"
import type { CustomOrderPage, OrderDetail } from "../lib/medusa"
import { OrderBooking } from "./book-delivery"

/** A site order's delivery booking, prefilled from the order (the address as the customer typed it at checkout). */
export function BookDeliveryPanel({ order }: { order: OrderDetail }) {
  const name = splitName(order.boxnow.name || order.customer)
  return (
    <OrderBooking
      orderKey={order.id}
      source="site"
      orderId={order.id}
      customerRef={order.display_id != null ? `#${order.display_id}` : order.ref}
      prefill={{
        kind: order.delivery === "home" ? "HOME" : "MEETUP",
        ...name,
        instagram: order.instagram ?? "",
        phone: order.phone ?? "",
        email: order.email ?? "",
        addressLine: order.delivery === "home" ? order.address.line ?? "" : "",
        addressArea: order.delivery === "home" ? order.address.city ?? "" : "",
        postalCode: order.delivery === "home" ? (order.address.postcode ?? "").replace(/\s/g, "") : "",
      }}
    />
  )
}

/**
 * A custom order's delivery booking, for meet-up and home-delivery orders (the delivery chosen in HQ,
 * else the sheet's). Prefilled from the sheet's customer box, read the same way as the BOX NOW lines.
 */
export function CustomBookingPanel({ page }: { page: CustomOrderPage }) {
  const { order } = page
  const delivery = page.state?.delivery ?? order.delivery
  if ((delivery !== "meetup" && delivery !== "home") || order.status === "cancelled") return null
  const address = delivery === "home" ? addressParts(page.boxnow.address) : { addressLine: "", addressArea: "", postalCode: "" }
  return (
    <OrderBooking
      orderKey={bookingKeyOfCustom(order.order_number)}
      source="custom"
      orderNumber={order.order_number}
      customerRef={`#${order.order_number}`}
      prefill={{
        kind: delivery === "home" ? "HOME" : "MEETUP",
        ...splitName(page.boxnow.name),
        instagram: order.handle.replace(/^@/, "").trim(),
        phone: page.boxnow.phone,
        email: page.boxnow.email,
        ...address,
      }}
    />
  )
}
